import { createApp } from 'vue';
import App from './App.vue';
import './style.css';
import { useTheme } from './composables/useTheme';
import { mediaCache } from './services/mediaCacheService';

const app = createApp(App);
useTheme().initTheme();
app.mount('#app');

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  const registerOfflineShell = async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
      await mediaCache.ensureAppShellPresaved();
      const sw = reg.active || reg.waiting || reg.installing;
      if (sw) {
        const sendWarm = () => {
          void mediaCache.ensureAppShellPresaved();
        };
        if (sw.state === 'activated') {
          sendWarm();
        } else {
          sw.addEventListener('statechange', () => {
            if (sw.state === 'activated') {
              sendWarm();
            }
          });
        }
      }
    } catch {
      // Ignore registration error in unsupported contexts
    }
  };

  if (document.readyState === 'complete') {
    void registerOfflineShell();
  } else {
    window.addEventListener('load', () => {
      void registerOfflineShell();
    });
  }
}
